import { formatTimestamp } from '../lib/format.js';
import type { WebhookDeadLetter, WebhookDelivery } from '../lib/api.js';

export interface WebhooksTableProps {
  readonly deliveries: readonly WebhookDelivery[];
  readonly deadLetters: readonly WebhookDeadLetter[];
  readonly onRefresh?: () => void;
}

export function WebhooksTable({
  deliveries,
  deadLetters,
  onRefresh,
}: WebhooksTableProps) {
  return (
    <div className="card" aria-label="webhooks-table">
      <div className="row" style={{ marginBottom: 8 }}>
        <h2 style={{ margin: 0 }}>Webhook Teslimatları</h2>
        {onRefresh ? (
          <button className="btn secondary" onClick={onRefresh}>↻</button>
        ) : null}
      </div>
      {deliveries.length === 0 && deadLetters.length === 0 ? (
        <div className="muted" style={{ fontSize: 13 }}>Henüz teslimat yok.</div>
      ) : null}
      {deliveries.length > 0 ? (
        <table style={{ marginBottom: deadLetters.length > 0 ? 16 : 0 }}>
          <thead>
            <tr>
              <th>Zaman</th>
              <th>Event</th>
              <th>Durum</th>
              <th>HTTP</th>
              <th>Deneme</th>
            </tr>
          </thead>
          <tbody>
            {deliveries.map((d) => (
              <tr key={d.eventId}>
                <td className="mono">{formatTimestamp(d.deliveredAt)}</td>
                <td className="mono">{d.eventId}</td>
                <td>
                  <span className={`pill ${d.success ? 'ok' : 'error'}`}>
                    {d.success ? 'delivered' : 'failed'}
                  </span>
                </td>
                <td className="mono">{d.status}</td>
                <td className="mono">{d.attempts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
      {deadLetters.length > 0 ? (
        <>
          <h2 style={{ margin: '8px 0' }}>Dead Letter Queue</h2>
          <table>
            <thead>
              <tr>
                <th>Zaman</th>
                <th>Event</th>
                <th>Son Hata</th>
              </tr>
            </thead>
            <tbody>
              {deadLetters.map((d) => (
                <tr key={d.eventId}>
                  <td className="mono">{formatTimestamp(d.enqueuedAt)}</td>
                  <td className="mono">{d.eventId}</td>
                  <td className="mono">
                    {d.lastResult.status} — {d.lastResult.body.slice(0, 80)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : null}
    </div>
  );
}
